export type { TypeAccountSettingsPageTranslations } from './TypeAccountSettingsPageTranslations';
export type { TypeAddMoreSaveMorePageTranslations } from './TypeAddMoreSaveMorePageTranslations';
export type { TypeMyAccountPageTranslations } from './TypeMyAccountPageTranslations';
export type { TypeSubscriberShopPageTranslations } from './TypeSubscriberShopPageTranslations';
export * from './TypeLanguagesAndLocales';
